class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems =
        this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class GiftCampaignManager {
  constructor(cartItems, getSectionsToRender) {
    this.getSectionsToRender = getSectionsToRender;
    this.cartItems = cartItems;
    if (!GiftCampaignManager.cartAddEventAdded) {
      document.addEventListener('cart:add', this.onCartAdd.bind(this));
      GiftCampaignManager.cartAddEventAdded = true;
    }
    if (!GiftCampaignManager.cartUpdateEventAdded) {
      document.addEventListener('cart:update', this.onCartUpdate.bind(this));
      GiftCampaignManager.cartUpdateEventAdded = true;
    }
  }

  onCartAdd(event) {    
    if (!window.gift_campaigns) {
      return;
    }
    const giftCombinations = window.gift_campaigns.combinations;
    const selectedVariantId = parseInt(
      event.detail.productForm?.querySelector('[name=id]')?.value
    );
    
    let isEventProduct = giftCombinations.find((combination) =>
      combination?.eligible_variants.includes(selectedVariantId)
    );
    let secondaryCombinations = giftCombinations.filter(
      (combination) => combination?.gift_is_secondary == true
    );
    let secondaryVariantIds = [];
    secondaryCombinations.map((combination) => {
      secondaryVariantIds.push(combination?.gift_variant_id);
    });
    let isEventProductSecondary = secondaryVariantIds.includes(
      isEventProduct?.gift_variant_id
    );
    let giftVariantId = isEventProduct?.gift_variant_id; // free item for selected product
    // all free items from the combinations
    let giftVariantIds = giftCombinations.map(
      (combination) => combination.gift_variant_id
    );

    let cartContents = document.getElementById('CartDrawerContent')
      ? JSON.parse(document.getElementById('CartDrawerContent').textContent)
      : undefined;
    let cartHasFreeItem = this.isFreeGiftInCart(
      cartContents.items,
      giftVariantIds
    );
    let secondaryFreeProductInCart = secondaryCombinations.find(
      (combination) =>
        this.isFreeGiftInCart(cartContents.items, [
          combination.gift_variant_id,
        ])
    );

    // if cart does not have the free product, add it    
    if (!cartHasFreeItem && isEventProduct) {
      this.handleGiftProduct(this.cartItems, giftVariantId, false);
    }

    // if cart has a free product, but it is a secondary free product, and the new free product is a primary free product, remove the secondary free product and add the new primary free product
    if (
      cartHasFreeItem &&
      secondaryFreeProductInCart &&
      isEventProduct &&
      !isEventProductSecondary
    ) {
      this.handleGiftProduct(
        this.cartItems,
        giftVariantId,
        secondaryFreeProductInCart.gift_variant_id
      );
    }
  }

  isFreeGiftInCart(cartItems, giftVariantIdsArr) {
    let cartItemsArr = cartItems.map((item) => item.id);
    // check cart items against free gift variant ids
    for (let ii = 0; ii < cartItemsArr.length; ii++) {
      for (let jj = 0; jj < giftVariantIdsArr.length; jj++) {
        if (cartItemsArr[ii] == giftVariantIdsArr[jj]) {
          return true;
        }
      }
    }
    return false;
  }

  onCartUpdate(event) {
    if (!window.gift_campaigns) {
      return;
    }
    let cartState = event.detail.cartState;    
    let giftsManuallyRemoved = false;
    if (sessionStorage.getItem('giftsManuallyRemoved')) {
      giftsManuallyRemoved = JSON.parse(
        sessionStorage.getItem('giftsManuallyRemoved')
      );
    }
    let cartItems = cartState.items;
    let cartVariantIds = cartItems.map((item) => item.variant_id);
    let giftCombinations = window.gift_campaigns.combinations;
    let allPrimaryCombinations = window.gift_campaigns.all_primary_combinations;
    let primaryEligibleVariants =
      window.gift_campaigns.primary_eligible_variants;
    let secondaryEligibleVariants =
      window.gift_campaigns.secondary_eligible_variants;
    let primaryGiftVariants = window.gift_campaigns.primary_gift_variants;

    let primaryCombinations = giftCombinations.filter(
      (combination) => combination.gift_is_secondary == false
    );
    let secondaryCombinations = giftCombinations.filter(
      (combination) => combination.gift_is_secondary == true
    );
    let primaryVariantInCart = primaryEligibleVariants.some((variant) =>
      cartVariantIds.includes(variant)
    );
    let secondaryVariantInCart = secondaryEligibleVariants.some((variant) =>
      cartVariantIds.includes(variant)
    );

    console.log("primaryVariantInCart", primaryVariantInCart);
    

    if (primaryVariantInCart) {
      let isOnePrimaryCombinationInCart = false;
      allPrimaryCombinations.forEach((combination) => {
        if (this.checkSubset(cartVariantIds, combination)) {
          isOnePrimaryCombinationInCart = true;
        }
      });
      if (!isOnePrimaryCombinationInCart) {
        let primaryGiftInCartToRemove = this.getMatchingItem(
          cartVariantIds,
          primaryGiftVariants
        );
        let primaryEligibleVariant = this.getMatchingItem(
          cartVariantIds,
          primaryEligibleVariants
        );
        let matchingPrimaryCombination = primaryCombinations.find(
          (combination) => {
            if (giftsManuallyRemoved) {
              return (
                combination.eligible_variants.includes(
                  primaryEligibleVariant
                ) && !giftsManuallyRemoved.includes(combination.gift_variant_id)
              );
            } else {
              return combination.eligible_variants.includes(
                primaryEligibleVariant
              );
            }
          }
        );
        let primaryGiftVariantToAdd =
          matchingPrimaryCombination?.gift_variant_id;

        if (primaryGiftVariantToAdd) {
          this.handleGiftProduct(
            this.cartItems,
            primaryGiftVariantToAdd,
            primaryGiftInCartToRemove
          );
        }
      } else {
        if (window.gift_campaigns.min_order_value) {
          let primaryGiftInCartToRemove = this.getMatchingItem(
            cartVariantIds,
            primaryGiftVariants
          );
          let primaryGiftInCartPrice = cartState.items.find(item => item.id == primaryGiftInCartToRemove)?.final_line_price;
          let cartTotalWithoutGift = cartState.total_price - primaryGiftInCartPrice;
          if (cartTotalWithoutGift < window.gift_campaigns.min_order_value) {
            this.handleGiftProduct(
              this.cartItems,
              false,
              primaryGiftInCartToRemove
            );
          }
        }
      }
    }

    if (!primaryVariantInCart && secondaryVariantInCart) {
      // remove primary gift if any and add secondary gift
      let primaryGiftInCartToRemove = this.getMatchingItem(
        cartVariantIds,
        primaryGiftVariants
      );
      let secondaryEligibleVariant = this.getMatchingItem(
        cartVariantIds,
        secondaryEligibleVariants
      );
      let matchingSecondaryCombination = secondaryCombinations.find(
        (combination) => {
          if (giftsManuallyRemoved) {
            return (
              combination.eligible_variants.includes(
                secondaryEligibleVariant
              ) && !giftsManuallyRemoved.includes(combination.gift_variant_id)
            );
          } else {
            return combination.eligible_variants.includes(
              secondaryEligibleVariant
            );
          }
        }
      );
      let secondaryGiftVariantToAdd =
        matchingSecondaryCombination?.gift_variant_id;

       if (window.gift_campaigns.min_order_value) {
        let secondaryGiftInCartPrice = cartState.items.find(item => item.id == secondaryGiftVariantToAdd)?.final_line_price;
        let cartTotalWithoutGift = cartState.total_price - secondaryGiftInCartPrice;
        if (cartTotalWithoutGift < window.gift_campaigns.min_order_value) {
          this.handleGiftProduct(
            this.cartItems,
            false,
            secondaryGiftVariantToAdd
          );
        } else {
          if (secondaryGiftVariantToAdd) {
            this.handleGiftProduct(
              this.cartItems,
              secondaryGiftVariantToAdd,
              primaryGiftInCartToRemove
            );
          }
        }
      } else {
        if (secondaryGiftVariantToAdd) {
          this.handleGiftProduct(
            this.cartItems,
            secondaryGiftVariantToAdd,
            primaryGiftInCartToRemove
          );
        }
      } 
  
    }

    if (!primaryVariantInCart && !secondaryVariantInCart) {      
      // if none of the primary or secondary products are in the cart, remove the gift product if any
      let giftVariantInCartToRemove = this.getMatchingItem(
        cartVariantIds,
        window.gift_campaigns.all_gift_variants
      );
      this.handleGiftProduct(
        this.cartItems,
        false,
        giftVariantInCartToRemove
      );
    }
  }

  handleGiftProduct(cartItems, giftVariantIdToAdd, giftVariantIdToRemove) {    
    let data = {
      sections: 'cart-drawer,cart-icon-bubble',
      updates: {},
    };

    let cartContents = document.getElementById('CartDrawerContent')
      ? JSON.parse(document.getElementById('CartDrawerContent').textContent)
      : undefined;

    if (giftVariantIdToAdd && ((!window.gift_campaigns.min_order_value) || (window.gift_campaigns.min_order_value && window.gift_campaigns.min_order_value <= cartContents.total_price))) {
      data.updates[giftVariantIdToAdd] = 1;
    }

    if (giftVariantIdToRemove) {
      data.updates[giftVariantIdToRemove] = 0;
    }

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    config.body = JSON.stringify(data);
    config.method = 'POST';
    
    fetch(`${routes.cart_update_url}`, config)
      .then((res) => res.json())
      .then((res) => {
        console.log("Gift script of handleGiftProduct fetch", res);
        
        cartItems.renderContents(res);
      })
      .catch((e) => {
        console.error(e);
      });
  }

  checkSubset(parentArray, subsetArray) {
    return subsetArray.every((el) => {
      return parentArray.includes(el);
    });
  }

  getMatchingItem(array1, array2) {
    let matchingItem = array1.filter((element) => array2.includes(element));
    if (matchingItem.length > 0) {
      return matchingItem[0];
    } else {
      return false;
    }
  }
}

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.giftCampaignManager = new GiftCampaignManager(this);
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') ||
      document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );
    
    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.initializeCartCheck();
    this.addEventListener('change', this.debouncedOnChange.bind(this));

    let allCartItems = (document.querySelector('cart-items')) ? Array.from(document.querySelector('cart-items').querySelectorAll('.cart-item')) : Array.from(this.querySelectorAll('.cart-item'));
    const giftBag = allCartItems.find((element) => element.dataset.type == 'gift-bag');

    let cartWeight = Number(this.dataset.cartWeight);
    let giftBigBag = this.dataset.giftBagBig;
    let giftSmallBag = (this.dataset.giftBagSmall != '') ? this.dataset.giftBagSmall : giftBigBag;
    
    let bagToAdd = (cartWeight <= 750) ? giftSmallBag : ((giftBigBag != '') ? (giftBigBag) : (giftSmallBag));
    let bagToRemove = (cartWeight <= 750 && giftBigBag != giftSmallBag) ? giftBigBag : giftSmallBag;        

    if (giftBag && giftBag.dataset.itemId != bagToAdd && giftBag.dataset.component == 'false') {
      setTimeout(() => {
        this.addGiftBag(this, bagToAdd, bagToRemove);
        console.log('Gift bag added');
        
      }, 1000);
    }
  }

  initializeCartCheck() {
    setTimeout(() => {
      fetch(window.Shopify.routes.root + 'cart.js')
      .then(response => response.json())
      .then(data => {  
        const result = data.items.filter((item) => item.vendor == "Additional service");
        const giftSmallBag = data.items.find((item) => item.sku == "BRO010-30x13x25-P-BAG-S1");
        const giftBigBag = data.items.find((item) => item.sku == "BRO010-39x35x17,5 -P-BAG-S1");
        
        if (result.length === data.item_count && data.item_count > 0) {
          if (document.querySelector('cart-items')) {
            document.querySelector('cart-items').cartClear();
          } else {
            this.cartClear();
          }
        }
        if (giftSmallBag && data.item_count == 1 && !giftSmallBag.properties._fromDefaultForm || giftBigBag && data.item_count == 1 && !giftBigBag.properties._fromDefaultForm) {
          if (document.querySelector('cart-items')) {
            document.querySelector('cart-items').cartClear();
          } else {
            this.cartClear();
          }
        }
      });
    }, 300);
  }

  addGiftBag(cart, giftVariantIdToAdd, giftVariantIdToRemove) {
    let section = this.getSectionsToRender().map((section) => section.section);

    if (window.location.pathname.includes('/cart')) {
      let cartItemsId = document.getElementById('main-cart-items').dataset.id;
      let giftWrapper = document.getElementById('gift-bag-wrapper');
      section = section + `,${cartItemsId}` + `,${giftWrapper}`;
    }

    let data = {
      sections: section,
      updates: {}
    };

    if (giftVariantIdToAdd) {
      data.updates[giftVariantIdToAdd] = 1;
    }

    if (giftVariantIdToRemove) {
      data.updates[giftVariantIdToRemove] = 0;
    }    

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    config.body = JSON.stringify(data);
    config.method = 'POST';
    
    fetch(`${routes.cart_update_url}`, config)
      .then((res) => res.json())
      .then((res) => 
        this.renderContents(res)
      )
      .catch((e) => {
        console.error(e);
      });
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute('name')
    );
    const cartUpdateEvent = new CustomEvent('cart:update', {
      detail: event
    });
    document.dispatchEvent(cartUpdateEvent);
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-sidebar',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.cart-sidebar .js-contents',
      },
      {
        id: 'gift-bag-wrapper',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.gift-bag-wrapper .js-contents',
      },
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
    ];
  }

  cartClear() {
    let section = this.getSectionsToRender().map((section) => section.section);

    let data = {
      sections: section,
      updates: {},
    };

    fetch(window.Shopify.routes.root + 'cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
      })
      .then((response) => response.json())
      .then(response => {
        setTimeout(() => {
          this.renderContents(response)
        }, 100);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  renderContents(parsedState) {    
    if (parsedState.item_count == 0) {
      document.querySelector('cart-drawer').classList.add('is-empty');
      document.querySelector('cart-items')?.classList.add('is-empty');
      document.querySelector('#gift-bag-wrapper')?.classList.add('hidden');
    }
    this.getSectionsToRender().forEach((section) => {
      const elementToReplace =
        document.getElementById(section.id).querySelector(section.selector) ||
        document.getElementById(section.id);
      
      elementToReplace.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.section],
        section.selector
      );
    });
    cartdrawerFreeShippingNote();
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    /* Gift script - check if removed item is a gift */
    let lineToRemove, lineIsGiftVariantId, lineIsGift;
    if (window.gift_campaigns) {
      lineToRemove =
        document.getElementById(`CartItem-${line}`) ||
        document.getElementById(`CartDrawer-Item-${line}`);
      // if customer manually removes the gift product, add it to sessionStorage array so it can't be added back to cart again automatically
      lineIsGiftVariantId = parseInt(lineToRemove.dataset.itemId);
      lineIsGift =
        window.gift_campaigns.all_gift_variants.includes(lineIsGiftVariantId);
      if (lineIsGift && quantity == 0) {
        let giftsManuallyRemoved = sessionStorage.getItem(
          'giftsManuallyRemoved'
        );
        if (giftsManuallyRemoved) {
          if (!giftsManuallyRemoved.includes(lineIsGiftVariantId)) {
            let giftsManuallyRemovedArray = JSON.parse(giftsManuallyRemoved);
            giftsManuallyRemovedArray.push(
              parseInt(lineToRemove.dataset.itemId)
            );
            sessionStorage.setItem(
              'giftsManuallyRemoved',
              JSON.stringify(giftsManuallyRemovedArray)
            );
          }
        } else {
          sessionStorage.setItem(
            'giftsManuallyRemoved',
            JSON.stringify([parseInt(lineToRemove.dataset.itemId)])
          );
        }
      }
    }

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');
                
        if (cartFooter)
          cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            'is-empty',
            parsedState.item_count === 0
          );

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem =
          document.getElementById(`CartItem-${line}`) ||
          document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(
                cartDrawerWrapper,
                lineItem.querySelector(`[name="${name}"]`)
              )
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper.querySelector('.drawer__inner-empty'),
            cartDrawerWrapper.querySelector('a')
          );
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper,
            document.querySelector('.cart-item__name')
          );
        }
        this.disableLoading();
        cartdrawerFreeShippingNote();

        const event = new CustomEvent('cart:update', {
          detail: {
            cartState: parsedState,
          }
        });
        document.dispatchEvent(event);
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) =>
          overlay.classList.add('hidden')
        );
        const errors =
          document.getElementById('cart-errors') ||
          document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
      })
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError =
        document.getElementById(`Line-item-error-${line}`) ||
        document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement =
        document.getElementById(`Quantity-${line}`) ||
        document.getElementById(`Drawer-quantity-${line}`);
      lineItemError.querySelector('.cart-item__error-text').innerHTML =
        window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityElement.value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') ||
      document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById('main-cart-items') ||
      document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading-overlay`
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove('hidden')
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems =
      document.getElementById('main-cart-items') ||
      document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'change',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            });
          }, 300)
        );
      }
    }
  );
}
